import { TREE_LEAF_LAYERS, TREE_TRUNK_HEIGHT, TileType } from './constants';

export interface TreeBlock {
    x: number;
    y: number;
    tileType: TileType;
}

export function buildTreeBlocks(centerX: number, baseY: number): TreeBlock[] {
    const blocks: TreeBlock[] = [];

    for (let i = 0; i < TREE_TRUNK_HEIGHT; i++) {
        const ty = baseY - i;
        blocks.push({ x: centerX, y: ty, tileType: TileType.TRUNK });
    }

    let leafY = baseY - TREE_TRUNK_HEIGHT;
    for (const layer of TREE_LEAF_LAYERS) {
        for (let r = 0; r < layer.rows; r++) {
            for (let dx = -layer.halfWidth; dx <= layer.halfWidth; dx++) {
                blocks.push({ x: centerX + dx, y: leafY, tileType: TileType.LEAVES });
            }
            leafY--;
        }
    }

    return blocks;
}
